<template>
  <!-- Once paired and in main UI, we show banner, not whole screen error -->
  <template v-if="showSlotContent">
    <slot></slot>
  </template>
  <template v-else>
    <div
      class="flex h-full flex-col items-center justify-between bg-background-fg/5 p-6"
    >
      <IconBrandLogo class="mx-2 h-auto w-full" />

      <IconWifiOff class="size-32 text-background-fg/50" />

      <div class="font-bold text-background-fg/50">
        Network offline
      </div>

      <div
        class="self-stretch overflow-hidden rounded-lg bg-background"
      >
        <MoreMenuItemInfo
          label="Network Status"
          :value="isOnline ? 'connected' : 'not connected'"
        />
        <MoreMenuItemInfo
          label="Connection Type"
          :value="connectionType"
        />
        <MoreMenuItemAction
          :icon="IconWifi"
          label="WIFI Settings"
          description="Access terminal wifi settings"
          @click="openWifiSettings"
        />
        <MoreMenuItemAction
          :icon="IconCellular"
          label="Cellular Settings"
          description="Access terminal cellular settings"
          @click="openCellularSettings"
        />
      </div>

      <ActionButtonSecondary
        class="self-stretch bg-background"
        @click="handleContinueWithoutNetwork"
      >
        Continue without network
      </ActionButtonSecondary>
    </div>
  </template>
</template>

<script setup lang="ts">
import { INetworkSettings } from "@/androidPlugins/INetworkSettings"
import {
  IconWifi,
  IconCellular,
  IconWifiOff,
  IconBrandLogo,
} from "@/icons"

import { useNetwork } from "@vueuse/core"
import * as Sentry from "@sentry/vue"

const { isOnline, type: connectionType } = useNetwork()
const { accessToken } = useAuth()
const { openCellularSettings, openWifiSettings } =
  INetworkSettings

const continueWithoutNetworkEnabled = ref(false)

const handleContinueWithoutNetwork = () => {
  continueWithoutNetworkEnabled.value = true
}

const showSlotContent = computed(
  () =>
    isOnline.value ||
    accessToken.value !== null ||
    continueWithoutNetworkEnabled.value
)

watchEffect(() => {
  if (!accessToken.value) {
    continueWithoutNetworkEnabled.value = false
  }
})

watchEffect(() => {
  Sentry.setTag(
    "network.connectionType",
    connectionType.value
  )
})
</script>
